function stopPropagation(event: Event) {
  event.stopPropagation();
}
function stopPropagationCallback(callback?: (event?: Event) => void) {
  return (event: Event) => {
    event.stopPropagation();
    if (callback) {
      callback(event);
    }
  };
}
function preventDefault(event: Event) {
  event.preventDefault();
}
function preventDefaultCallback(callback?: (event?: Event) => void) {
  return (event: Event) => {
    event.preventDefault();
    if (callback) {
      callback(event);
    }
  };
}
function composeEventHandlers<E>(
  originalEventHandler?: (event: E, ...args: any) => void,
  ourEventHandler?: (event: E) => void,
  { checkForDefaultPrevented = true } = {}
) {
  return function handleEvent(event: E, ...args: any) {
    originalEventHandler?.(event, ...args);

    if (checkForDefaultPrevented === false || !(event as unknown as Event).defaultPrevented) {
      return ourEventHandler?.(event);
    }
  };
}
export { stopPropagation, preventDefault, stopPropagationCallback, preventDefaultCallback, composeEventHandlers };
